/**
 * A count somebody has to read off a screen, grouped the Slovak way.
 *
 * `2464` is a number an operator then decides whether to send 2 464 messages to; at that size the
 * grouping is not decoration. Second page to need it — `/marketing-customers` and
 * `/loyalty-program` — so it lives here rather than in either.
 */
const COUNT_FORMAT = new Intl.NumberFormat('sk-SK')

export function formatCount(value: number): string {
  return COUNT_FORMAT.format(value)
}
